// extracted by mini-css-extract-plugin
export var modal = "_bc-0";